import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import RechargeModal from './RechargeModal';

// Pricing Section Component - Displays pricing plans above FAQ
const PricingSection = () => {
  const { isAuthenticated, login } = useAuth();
  const [showRechargeModal, setShowRechargeModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  // Pricing plans data
  const pricingPlans = [
    {
      name: 'Starter Pack',
      price: '₹2,500',
      credits: '100 Credits',
      generations: '50 Image Generations',
      features: [
        '50 Image Generations',
        'All 3 Feature Types',
        'HD Quality Output',
        'Whatsapp Support',
        'Size Selector',
        'Angle Selector',
        'Shopify Integration'
      ],
      creditsValue: 100,
      isPopular: false
    },
    {
      name: 'Business',
      price: '₹12,500',
      credits: '500 Credits',
      generations: '250 Image Generations',
      features: [
        '250 Image Generations',
        'All 3 Feature Types',
        'HD Quality Output',
        'Whatsapp Support',
        'Size Selector',
        'Angle Selector',
        'Shopify Integration'
        
      ],
      creditsValue: 500,
      isPopular: true
    },
    {
      name: 'Professional',
      price: '₹25,000',
      credits: '1000 Credits',
      generations: '500 Image Generations',
      features: [
        '500 Image Generations',
        'All 3 Feature Types',
        'HD Quality Output',
        'Whatsapp Support',
        'Size Selector',
        'Angle Selector',
        'Shopify Integration'
      ],
      creditsValue: 1000,
      isPopular: false
    }
  ];

  // Handle plan selection
  const handleChoosePlan = (plan) => {
    if (isAuthenticated()) {
      // User is logged in - open recharge modal with selected package
      setSelectedPackage(plan.creditsValue);
      setShowRechargeModal(true);
    } else {
      // User is not logged in - trigger login
      login();
    }
  };

  // Handle recharge modal close
  const handleCloseRecharge = () => {
    setShowRechargeModal(false);
    setSelectedPackage(null);
  };

  // Handle recharge success
  const handleRechargeSuccess = () => {
    setShowRechargeModal(false);
    setSelectedPackage(null);
  };

  // Handle free trial button
  const handleFreeTrial = () => {
    if (isAuthenticated()) {
      // Already logged in, scroll to top or show a message
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Trigger login
      login();
    }
  };

  return (
    <section className="pricing-section">
      <div className="pricing-section-container">
        {/* Header */}
        <div className="pricing-section-header">
          <h2 className="pricing-section-title">Simple, Transparent Pricing</h2>
          <p className="pricing-section-subtitle">
            Each image generation uses 2 credits. Start with 10 free credits (₹250 value)
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="pricing-cards-wrapper">
          {pricingPlans.map((plan, index) => (
            <div 
              key={index} 
              className={`pricing-card-section ${plan.isPopular ? 'pricing-card-popular' : ''}`}
            >
              {plan.isPopular && (
                <div className="pricing-popular-badge">Most Popular</div>
              )}
              <div className="pricing-card-content">
                <h3 className="pricing-card-name">{plan.name}</h3>
                <div className="pricing-card-price">{plan.price}</div>
                <div className="pricing-card-credits">{plan.credits}</div>
                <ul className="pricing-card-features">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="pricing-feature-item">
                      <span className="pricing-feature-icon">✓</span>
                      <span className="pricing-feature-text">{feature}</span>
                    </li>
                  ))}
                </ul>
                <button
                  className={`pricing-card-button ${plan.isPopular ? 'pricing-card-button-primary' : 'pricing-card-button-secondary'}`}
                  onClick={() => handleChoosePlan(plan)}
                >
                  Choose {plan.name}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="pricing-section-cta">
          <p className="pricing-cta-question">Not sure which plan is right for you?</p>
          <button className="pricing-cta-button" onClick={handleFreeTrial}>
            Start with Free Trial
          </button>
        </div>
      </div>

      {/* Recharge Modal */}
      {isAuthenticated() && (
        <RechargeModal
          isOpen={showRechargeModal}
          onClose={handleCloseRecharge}
          onSuccess={handleRechargeSuccess}
          initialCredits={selectedPackage}
        />
      )}
    </section>
  );
};

export default PricingSection;

